module.exports = __webpack_public_path__ + "img/125.c0c7a708.png";